import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Button from '../../../refresh/atoms/button';

import Text from '../../../refresh/atoms/Text';

// import styles from './index.pcss';

class ResetAddressLuxe extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { initialaddresss, resetButton, hideDialog } = this.props;
    return (
      <div className="reset-popup-container">
        <div className="card-body">
          <div className="text-container">
            <Text variant="T4" weight="bold">
              Reset Address
            </Text>
          </div>

          <Text color="Dark_Grey">
            This address reset all the changes you have made.Procced only if you want these chanages
            be discarded.
          </Text>
        </div>
        <div className="reset-popup-button">
          <div className="left-button">
            <Button
              ariaLabel="RESET"
              btnLabel="RESET"
              variant="secondary"
              fullWidth
              onClick={e => resetButton(e)}
              id="leftButton"
              emphasis
            />
          </div>
          <div className="right-button">
            <Button
              ariaLabel="CANCEL"
              btnLabel="CANCEL"
              variant="primary"
              fullWidth
              onClick={() => hideDialog()}
              id="rightButton"
              emphasis
            />
          </div>
        </div>
      </div>
    );
  }
}

// ResetAddressLuxe.defaultProps = {
//   addToWishListHandler: noop,
//   removeHandler: noop,

// };

export default ResetAddressLuxe;
